import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getLocalCurrencyStr } from '@beef/utils';
import { ATTRIBUTES_NAME, CARD_TYPE, CATEGORIES, CATEGORY_LIST, ECard, UNIT } from "./constants";
var getSubtitleCompact = function getSubtitleCompact(price, unit) {
  var textUnit = unit ? "/".concat(unit) : '';
  var priceValue = Number(price);
  if (!Number.isNaN(priceValue) && (priceValue || priceValue === 0)) {
    return "".concat(getLocalCurrencyStr(price)).concat(textUnit);
  }
  return '';
};
var preparedPrice = function preparedPrice(type, price) {
  var unit = type === CARD_TYPE.tariff ? UNIT : '';
  if (type === CARD_TYPE.product) {
    return getLocalCurrencyStr(price);
  }
  if (type === CARD_TYPE.service) {
    var priceValue = Number(price) || 'none';
    return getSubtitleCompact(priceValue, unit);
  }
  if (type === CARD_TYPE.tariff) {
    return getSubtitleCompact(price, unit);
  }
  return '';
};
export var getCompactInfo = function getCompactInfo(cards, cardType) {
  return cards.filter(function (card) {
    var _card$categories;
    if (cardType === CARD_TYPE.product) {
      var _card$attributes;
      return (_card$attributes = card.attributes) === null || _card$attributes === void 0 ? void 0 : _card$attributes[ATTRIBUTES_NAME.product];
    }
    return ((_card$categories = card.categories) === null || _card$categories === void 0 ? void 0 : _card$categories[0].id) === CATEGORIES[cardType];
  }).sort(function (a, b) {
    return ((b === null || b === void 0 ? void 0 : b.score) || 0) - ((a === null || a === void 0 ? void 0 : a.score) || 0);
  }).slice(0, 5).map(function (element) {
    var _element$attributes, _element$attributes$i, _element$attributes2;
    var price = preparedPrice(cardType, element.price);
    var imageUrl = cardType === CARD_TYPE.product ? element.image_url : ((_element$attributes = element.attributes) === null || _element$attributes === void 0 ? void 0 : (_element$attributes$i = _element$attributes.icon_url) === null || _element$attributes$i === void 0 ? void 0 : _element$attributes$i[0]) || ((_element$attributes2 = element.attributes) === null || _element$attributes2 === void 0 ? void 0 : _element$attributes2.icon_url);
    return {
      href: element.link_url,
      id: element.id,
      image_url: imageUrl,
      subtitle: price,
      title: element.name,
      brand: element.brand,
      score: element.score,
      category: cardType
    };
  });
};
var getOthers = function getOthers(articles) {
  var _articles$slice;
  return articles === null || articles === void 0 ? void 0 : (_articles$slice = articles.slice(0, 5)) === null || _articles$slice === void 0 ? void 0 : _articles$slice.map(function (article) {
    return {
      id: article.id,
      href: article.link_url,
      title: article.name,
      category: CARD_TYPE.other
    };
  });
};
var getTaps = function getTaps(taps) {
  var _taps$slice;
  return taps === null || taps === void 0 ? void 0 : (_taps$slice = taps.slice(0, 6)) === null || _taps$slice === void 0 ? void 0 : _taps$slice.map(function (tap, index) {
    return {
      key: index,
      label: tap.tap,
      relatedSearch: tap.relatedSearch
    };
  });
};
export var prepareResponseData = function prepareResponseData(data) {
  return {
    correction: data.correction || '',
    taps: getTaps(data.taps),
    elk: getCompactInfo(data.products, CARD_TYPE.elk),
    tariffs: getCompactInfo(data.products, CARD_TYPE.tariff),
    products: getCompactInfo(data.products, CARD_TYPE.product),
    services: getCompactInfo(data.products, CARD_TYPE.service),
    others: getOthers(data.contents)
  };
};
var getLimit = function getLimit(categories, positions) {
  if (!categories) {
    return 0;
  }
  if (categories === 3 && positions >= 6 || categories === 4 && positions > 8 || categories === 5 && positions > 11) {
    return 3;
  }
  return 4;
};
var prepareLimit = function prepareLimit(responseData) {
  var positions = 0;
  var categories = CATEGORY_LIST.reduce(function (accum, category) {
    var _responseData$categor;
    var currentPositions = (_responseData$categor = responseData[category]) === null || _responseData$categor === void 0 ? void 0 : _responseData$categor.length;
    if (currentPositions) {
      accum.push(category);
      positions += currentPositions;
    }
    return accum;
  }, []);
  var countCategories = (categories === null || categories === void 0 ? void 0 : categories.length) || 0;
  return {
    availableCategories: categories,
    limit: getLimit(countCategories, positions)
  };
};
export var prepareResult = function prepareResult(data) {
  var responseData = prepareResponseData(data);
  var _prepareLimit = prepareLimit(responseData),
    availableCategories = _prepareLimit.availableCategories,
    limit = _prepareLimit.limit;
  if (!limit) {
    return _objectSpread(_objectSpread({}, responseData), {}, {
      isEmpty: true
    });
  }
  var categories = availableCategories.reduce(function (acc, category) {
    var _responseData$categor2;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var slicedCategory = (_responseData$categor2 = responseData[category]) === null || _responseData$categor2 === void 0 ? void 0 : _responseData$categor2.slice(0, limit);
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, category, slicedCategory));
  }, {});
  return _objectSpread(_objectSpread(_objectSpread({}, responseData), categories), {}, {
    isEmpty: false
  });
};

/** Функция получения хендлеров для отправки аналитики при клике по карточкам в поиске
 * @param type {ECard} - тип карточки
 */
export var getMetricCellResultForClick = function getMetricCellResultForClick(type) {
  if (type && type !== ECard.other) {
    return ['handleClickSearchElementBlock', 'handleClickEcommerce', 'handleClickSearchElementDigi'];
  }
  return ['handleClickSearchElementBlock', 'handleClickEcommerce'];
};